import LazyPdfViewer from './LazyPdfViewer';
import { useLocation } from 'react-router-dom';

export default function LazyPdfViewerPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const url = searchParams.get('url');

  if (!url) return <div>未提供 PDF 文件</div>;

  return (
    <div>
      <h2>PDF 查看器</h2>
      <LazyPdfViewer url={url} />
    </div>
  );
}